/* tslint:disable */

declare var Object: any;
export interface ProductUomInterface {
  "id"?: number;
  "name": string;
}

export class ProductUom implements ProductUomInterface {
  "id": number;
  "name": string;
  constructor(data?: ProductUomInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductUom`.
   */
  public static getModelName() {
    return "ProductUom";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductUom for dynamic purposes.
  **/
  public static factory(data: ProductUomInterface): ProductUom{
    return new ProductUom(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductUom',
      plural: 'ProductUoms',
      path: 'ProductUoms',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductUom.ts